// Recovered compiled webpack factory 65025. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { $p: () => n, EC: () => r, Nu: () => s, iP: () => i });
  let r = "font-[family-name:var(--font-geist)]",
    n = "font-[family-name:var(--font-geist)] text-[16px] leading-[24px]",
    i = "font-['GeistMono','Geist_Mono',ui-monospace,monospace]",
    s = "font-[family-name:var(--font-overused)]";
}
